var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: _vm.onResize,
      expression: "onResize"
    }],
    key: 'signform' + _vm.pages.length,
    style: "height: calc(".concat(_vm.clientHeight, "px").concat(!_vm.isHeadless ? ' - 56px' : '', "); overflow-y: hidden; overflow-x: hidden;")
  }, [_c('v-row', {
    style: "height: calc(100% - 50px ".concat(_vm.pages.length > 1 ? '- 102px' : '', ");"),
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_vm.isLoading ? _c('v-skeleton-loader', {
    staticClass: "ma-auto",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "type": "image@4"
    }
  }) : _c('sign-form-editor-canvas', {
    key: 'pagecanvas' + _vm.currentPageNumber,
    ref: "detailCardEditor",
    attrs: {
      "sideBarElement": _vm.DocumentDetailSideBarElements.CLOSED,
      "isSignature": false,
      "isSigning": true,
      "isLoading": _vm.isLoading,
      "currentPageNumber": _vm.currentPageNumber,
      "pages": _vm.pages
    },
    on: {
      "setCurrentPage": _vm.setCurrentPage,
      "previousPage": _vm.previousPage,
      "nextPage": _vm.nextPage
    }
  })], 1), _vm.pages.length > 1 ? _c('v-btn', {
    staticStyle: {
      "position": "absolute",
      "top": "50%",
      "left": "5px"
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.previousPage
    }
  }, [_c('v-icon', [_vm._v(" mdi-chevron-left ")])], 1) : _vm._e(), _vm.pages.length > 1 ? _c('v-btn', {
    staticStyle: {
      "position": "absolute",
      "top": "50%",
      "right": "5px"
    },
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.nextPage
    }
  }, [_c('v-icon', [_vm._v(" mdi-chevron-right ")])], 1) : _vm._e()], 1)], 1), _vm.pages.length > 1 ? _c('v-row', {
    staticStyle: {
      "background-color": "#f5f5f5"
    },
    style: "height: 100px; overflow-y: hidden; margin-bottom:1px",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-sheet', {
    attrs: {
      "rounded": "tr-lg tl-lg",
      "elevation": 1
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "overflow-x": "auto",
      "width": "${clientWidth}px"
    }
  }, _vm._l(_vm.pages, function (page, index) {
    return _c('div', {
      key: 'pageNumber' + index
    }, [_c('sign-form-signature-page-list-sheet', {
      staticStyle: {
        "max-width": "100px",
        "max-height": "100px",
        "margin": "1px 4px 1px 4px"
      },
      attrs: {
        "id": _vm.PAGE_LIST_ID + index,
        "index": index,
        "currentPageNumber": _vm.currentPageNumber,
        "document": _vm.document,
        "page": page
      },
      on: {
        "setCurrentPage": _vm.setCurrentPage
      }
    })], 1);
  }), 0)])], 1)], 1) : _vm._e(), _c('sign-form-editor-controls', {
    ref: "signFormEditorControls",
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "width": "100%"
    },
    attrs: {
      "document": _vm.document,
      "currentPageNumber": _vm.currentPageNumber,
      "row": true,
      "pageCount": _vm.pages.length,
      "isMobile": true
    },
    on: {
      "previousPage": _vm.previousPage,
      "nextPage": _vm.nextPage,
      "setCurrentPage": _vm.setCurrentPage,
      "sign": function sign(signature) {
        return _vm.$emit('sign', signature);
      }
    }
  }), _c('v-dialog', {
    attrs: {
      "width": "400px",
      "persistent": ""
    },
    model: {
      value: _vm.isTokenDialogActive,
      callback: function callback($$v) {
        _vm.isTokenDialogActive = $$v;
      },
      expression: "isTokenDialogActive"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "d-flex"
  }, [_vm._v(" " + _vm._s("".concat(_vm.$t("sign.tokenDialog.title"), " (").concat(_vm.currentTokenIndex + 1, "/").concat(_vm.totalTokens, ")")) + " "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.resetHighlightedToken
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-card-subtitle', [_vm._v(" " + _vm._s(_vm.$t("sign.tokenDialog.subtitle")) + " ")]), _c('v-card-text', [_vm.highlightedToken ? _c('div', [_vm.isCrossToken(_vm.highlightedToken.token) ? _c('div', [_c('custom-field-boolean', {
    attrs: {
      "value": _vm.highlightedToken.value === _vm.SignatureTokenEnum.CROSS_TOKEN,
      "customField": {
        label: "".concat(_vm.highlightedToken.title || _vm.$t('sign.ReportDocumentSignRequestStepperForm.crossChecked')).concat(_vm.highlightedToken && _vm.highlightedToken.isRequired ? ' *' : '')
      },
      "required": _vm.highlightedToken.isRequired
    },
    on: {
      "input": function input($event) {
        return _vm.updateCrossToken(_vm.highlightedToken);
      }
    }
  }), _c('div', {
    staticClass: "v-messages__message mt-n7 mx-3 grey--text text--darken-2 text-caption"
  }, [_vm._v(" " + _vm._s(_vm.highlightedToken.description) + " ")])], 1) : _c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.highlightedToken.title,
      "hint": _vm.highlightedToken.description,
      "persistent-hint": ""
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.resetHighlightedToken.apply(null, arguments);
      }
    },
    model: {
      value: _vm.highlightedToken.value,
      callback: function callback($$v) {
        _vm.$set(_vm.highlightedToken, "value", $$v);
      },
      expression: "highlightedToken.value"
    }
  })], 1) : _vm._e()]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "disabled": _vm.isFirstToken,
      "elevation": 0,
      "outlined": ""
    },
    on: {
      "click": _vm.goToPreviousToken
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("back")) + " ")]), _c('v-btn', {
    attrs: {
      "elevation": 0,
      "color": "primary"
    },
    on: {
      "click": _vm.goToNextToken
    }
  }, [_vm._v(" " + _vm._s(_vm.isLastToken ? _vm.$t("close") : _vm.$t("next")) + " ")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }